module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "1c25");
/******/ })
/************************************************************************/
/******/ ({

/***/ "0e8c":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "194e":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "1c25":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: /home/kornel/workspace-otp/ui-common/node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("4141")
  }

  var i
  if ((i = window.document.currentScript) && (i = i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: /home/kornel/workspace-otp/ui-common/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bc1a0b24-vue-loader-template"}!/home/kornel/workspace-otp/ui-common/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/home/kornel/workspace-otp/ui-common/node_modules/pug-plain-loader!/home/kornel/workspace-otp/ui-common/node_modules/cache-loader/dist/cjs.js??ref--0-0!/home/kornel/workspace-otp/ui-common/node_modules/vue-loader/lib??vue-loader-options!./src/components/VueRadioGroup.vue?vue&type=template&id=673bceac&scoped=true&lang=pug&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',{staticClass:"sf-radio-group"},[_c('legend',{staticClass:"sf-radio-group__legend",class:{ 'sr-only' : _vm.isLegendHidden }},[_vm._v(" "+_vm._s(_vm.legend)),(_vm.hasError && _vm.errorMessages.length != 0)?_c('span',{staticClass:"sr-only"},_vm._l((_vm.errorMessages),function(errorMessage){return _c('span',[_vm._v(_vm._s(errorMessage))])}),0):_vm._e()]),_c('div',{staticClass:"sf-radio-group__container",class:{'sf-radio-group__container--mobile-inline' : _vm.mobileInline}},_vm._l((_vm.options),function(item,index){return _c('div',{staticClass:"sf-radio-group__pair"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],staticClass:"sf-radio-group__input sr-only",attrs:{"type":"radio","id":_vm.id + index,"name":_vm.id,"disabled":_vm.isDisabled},domProps:{"value":item.key,"checked":_vm._q(_vm.model,item.key)},on:{"change":function($event){_vm.model=item.key}}}),_c('label',{staticClass:"sf-radio-group__label",class:{ 'sf-radio--error' : _vm.hasError },attrs:{"for":_vm.id + index},domProps:{"innerHTML":_vm._s(item.value)}})])}),0),_vm._t("default",null,{"hasErrorMessage":_vm.hasErrorMessage,"hasError":_vm.hasError})],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/VueRadioGroup.vue?vue&type=template&id=673bceac&scoped=true&lang=pug&

// EXTERNAL MODULE: /home/kornel/workspace-otp/ui-common/node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("c880");

// CONCATENATED MODULE: /home/kornel/workspace-otp/ui-common/node_modules/cache-loader/dist/cjs.js??ref--12-0!/home/kornel/workspace-otp/ui-common/node_modules/thread-loader/dist/cjs.js!/home/kornel/workspace-otp/ui-common/node_modules/babel-loader/lib!/home/kornel/workspace-otp/ui-common/node_modules/cache-loader/dist/cjs.js??ref--0-0!/home/kornel/workspace-otp/ui-common/node_modules/vue-loader/lib??vue-loader-options!./src/components/VueRadioGroup.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var VueRadioGroupvue_type_script_lang_js_ = ({
  name: 'VueRadioGroup',
  data: function data() {
    return {
      id: null,
      model: null,
      errorMessages: [],
      hasErrorMessage: false
    };
  },
  props: {
    value: {
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    legend: {
      type: String,
      required: true
    },
    isLegendHidden: {
      type: Boolean,
      required: false,
      default: false
    },
    hasError: {
      type: Boolean,
      required: false,
      default: false
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    mobileInline: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  watch: {
    value: {
      handler: function handler(val) {
        this.model = val;
      },
      immediate: true
    },
    model: function model(val) {
      this.$emit('input', val);
    },
    hasError: function hasError(val) {
      if (val) {
        this.setErrorMessages();
      } else {
        this.resetErrorMessages();
      }
    }
  },
  methods: {
    setErrorMessages: function setErrorMessages() {
      var _this = this;

      this.$nextTick(function () {
        _this.errorMessages = _this.$children.filter(function (child) {
          return child.$options.name = 'VueErrorMessage';
        }).map(function (comp) {
          return comp.$el.innerText;
        });
        _this.hasErrorMessage = _this.errorMessages.length != 0;
      });
    },
    resetErrorMessages: function resetErrorMessages() {
      this.hasErrorMessage = false;
      this.errorMessages = [];
    }
  },
  mounted: function mounted() {
    this.id = this.$el.attributes[0].name + '-' + this._uid;
  }
});
// CONCATENATED MODULE: ./src/components/VueRadioGroup.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_VueRadioGroupvue_type_script_lang_js_ = (VueRadioGroupvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/VueRadioGroup.scss?vue&type=style&index=0&id=673bceac&lang=scss&scoped=true&
var VueRadioGroupvue_type_style_index_0_id_673bceac_lang_scss_scoped_true_ = __webpack_require__("d2ff");

// CONCATENATED MODULE: /home/kornel/workspace-otp/ui-common/node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/VueRadioGroup.vue






/* normalize component */

var component = normalizeComponent(
  components_VueRadioGroupvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "673bceac",
  null
  
)

/* harmony default export */ var VueRadioGroup = (component.exports);
// CONCATENATED MODULE: /home/kornel/workspace-otp/ui-common/node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (VueRadioGroup);



/***/ }),

/***/ "3d85":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("a124")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "4141":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "6f0d":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("8c7e");
var IE8_DOM_DEFINE = __webpack_require__("cd30");
var toPrimitive = __webpack_require__("78d3");
var dP = Object.defineProperty;

exports.f = __webpack_require__("3d85") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "78d3":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("194e");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "8c7e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("194e");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "9b86":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("194e");
var document = __webpack_require__("0e8c").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "a124":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "c880":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("6f0d").f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__("3d85") && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),

/***/ "cd30":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("3d85") && !__webpack_require__("a124")(function () {
  return Object.defineProperty(__webpack_require__("9b86")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "d2ff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_VueRadioGroup_scss_vue_type_style_index_0_id_673bceac_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f82d");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_VueRadioGroup_scss_vue_type_style_index_0_id_673bceac_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_VueRadioGroup_scss_vue_type_style_index_0_id_673bceac_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_VueRadioGroup_scss_vue_type_style_index_0_id_673bceac_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "f82d":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ })

/******/ })["default"];
//# sourceMappingURL=vue-radio-group.common.js.map